import clsx from "clsx"
import type { headers } from "next/headers"
import { type ClassNameValue, twMerge } from "tailwind-merge"
import type { WooCommerceProduct } from "@/services/woo-commerce-service"

export const cn = (...inputs: ClassNameValue[]) => twMerge(clsx(inputs))

const IMAGE_PROXY_BASE = "/api/image-proxy"

export function getImageWithFallback(src: string): string {
  if (!src) return ""
  const encoded = encodeURIComponent(src)
  return `${IMAGE_PROXY_BASE}?src=${encoded}`
}

export const getURL = (
  headersList: Awaited<ReturnType<typeof headers>>
): string => {
  const host = headersList.get("x-forwarded-host") ?? headersList.get("host")
  const protocol = headersList.get("x-forwarded-proto") ?? "https"

  return `${protocol}://${host}`
}

export const filterOutOfStockProducts = (
  products: WooCommerceProduct[]
): WooCommerceProduct[] => {
  return products.filter((product) => product?.stock_status === "instock")
}

export const formatCurrency = (num: number) => {
  const integerNum = Math.round(num)

  const formattedInteger = integerNum
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")

  return formattedInteger
}
